<template>
  <div class="submit-wrapper">
    <div v-show="showCheck" :style="vstyle" class="captcha" ref="captcha"></div>
    <slot v-if="!showCheck"> </slot>
  </div>
</template>

<script>
export default {
  name: "vcaptcha",
  props: {
    showCheck: {},
    nativeButton: {
      default() {
        return {};
      }
    },
    dialogVisible: {},
    vstyle: {}
  },
  data() {
    return {
      checkNeed: 0,
      captchaObj: {}
    };
  },
  computed: {
    captchaParams() {
      const {
        lot_number,
        captcha_output,
        pass_token,
        gen_time
      } = this.captchaObj;
      return { lot_number, captcha_output, pass_token, gen_time };
    }
  },
  watch: {
    dialogVisible(n) {
      !n && this.handleReset();
    }
  },
  mounted() {
    this.initGeetest4({}, () => this.$emit("cb"));
  },
  methods: {
    handleReset() {
      try {
        this.captcha.reset();
      } catch (error) {
        console.log(
          "🚀 ~ file: Regist.vue:343 ~ subform ~ error: captcha 初始化完毕"
        );
      }
    },
    initGeetest4(options, cb, captchaId = "8ee6f643518b02191b83e11a73c2520c") {
      initGeetest4(
        {
          captchaId,
          language: process.env.NODE_ENV == "development" ? "zho" : "vie",
          nativeButton: {
            width: "100%",
            ...this.nativeButton
            // height: "inherit"
          },
          ...options
        },
        captcha => {
          captcha
            .onReady(() => {
              //your code
            })
            .onSuccess(() => {
              this.captcha = captcha;
              this.captchaObj = captcha.getValidate();
              cb(captcha);
              //your code
            })
            .onError(() => {
              //your code
            });
          captcha.appendTo(this.$refs.captcha);
        }
      );
    }
  }
};
</script>

<style lang="less" scoped>
.submit-wrapper {
  display: flex;
  justify-content: center;
}
.captcha {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/common/captcha.vue